// extracted by mini-css-extract-plugin
export default {"container":"Portfolio_container__6NSLd","eyebrow":"Portfolio_eyebrow__oS8+g","status":"Portfolio_status__Lxc6V","projectGrid":"Portfolio_projectGrid__S2JUY"};